/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOpenMethodsWithCurrentAmount200ResponseInner
 */
export interface GetOpenMethodsWithCurrentAmount200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOpenMethodsWithCurrentAmount200ResponseInner
     */
    method: string;
    /**
     * 
     * @type {number}
     * @memberof GetOpenMethodsWithCurrentAmount200ResponseInner
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof GetOpenMethodsWithCurrentAmount200ResponseInner
     */
    currentAmount?: number;
}

/**
 * Check if a given object implements the GetOpenMethodsWithCurrentAmount200ResponseInner interface.
 */
export function instanceOfGetOpenMethodsWithCurrentAmount200ResponseInner(value: object): value is GetOpenMethodsWithCurrentAmount200ResponseInner {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    return true;
}

export function GetOpenMethodsWithCurrentAmount200ResponseInnerFromJSON(json: any): GetOpenMethodsWithCurrentAmount200ResponseInner {
    return GetOpenMethodsWithCurrentAmount200ResponseInnerFromJSONTyped(json, false);
}

export function GetOpenMethodsWithCurrentAmount200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOpenMethodsWithCurrentAmount200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'method': json['method'],
        'start': json['start'],
        'currentAmount': json['currentAmount'] == null ? undefined : json['currentAmount'],
    };
}

export function GetOpenMethodsWithCurrentAmount200ResponseInnerToJSON(json: any): GetOpenMethodsWithCurrentAmount200ResponseInner {
    return GetOpenMethodsWithCurrentAmount200ResponseInnerToJSONTyped(json, false);
}

export function GetOpenMethodsWithCurrentAmount200ResponseInnerToJSONTyped(value?: GetOpenMethodsWithCurrentAmount200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': value['method'],
        'start': value['start'],
        'currentAmount': value['currentAmount'],
    };
}

